{
    "Accessibility menu": "Меню доступности",
    "Close": "Закрыть",
    "Content adjustments": "Настройки контента",
    "Navigation adjustments": "Настройки навигации",
    "Text Align": "Text Align",
    "Align Left": "Выровнять по левому краю",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "Настроить размер шрифта",
    "Highlight Title": "Выделить заголовок",
    "Highlight Links": "Выделить ссылки",
    "Readable Font": "Читаемый шрифт",
    "Colour adjustments": "Настройки цвета",
    "Dark Contrast": "Темный контраст",
    "Light Contrast": "Светлый контраст",
    "High Contrast": "Высокий контраст",
    "High Saturation": "Высокая насыщенность",
    "Low Saturation": "Низкая насыщенность",
    "Monochrome": "Монохромный",
    "Tools": "Инструменты",
    "Reading Guide": "Руководство по чтению",
    "Big Cursor": "Большой курсор",
    "Increase Font Size": "Увеличить размер шрифта",
    "Decrease Font Size": "Уменьшить размер шрифта",
    "Letter Spacing": "Межбуквенный интервал",
    "Line Height": "Высота строки",
    "Font Weight": "Насыщенность шрифта",
    "Dyslexia Font": "Шрифт для дислексии",
    "Language": "Язык",
    "Accessibility widget": "Открыть меню доступности",
    "Accessibility Profiles": "Профили доступности",
    "Cognitive Disability": "Когнитивные нарушения",
    "Seizure Safe": "Безопасно при эпилепсии",
    "Accessibility statement": "Заявление о доступности",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "Остановить анимации",
    "Reset all settings": "Сбросить настройки",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
